import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "primary-navigation__first-level" }
const _hoisted_2 = ["href", "innerHTML"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "6",
  viewBox: "0 0 10 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.150007 0.411726C0.272462 0.319885 0.40257 0.270137 0.540333 0.262484C0.678095 0.25483 0.800551 0.304578 0.9077 0.411726L4.99464 4.49867L9.08159 0.411727C9.17343 0.304578 9.29588 0.254831 9.44895 0.262484C9.60202 0.270138 9.73213 0.319885 9.83928 0.411727C9.94643 0.534182 10 0.660463 10 0.790572C10 0.920681 9.94643 1.03931 9.83928 1.14646L5.45385 5.53189C5.37731 5.60842 5.30461 5.662 5.23573 5.69261C5.16685 5.72322 5.08648 5.73853 4.99464 5.73853C4.9028 5.73853 4.81861 5.72322 4.74208 5.69261C4.66554 5.662 4.58901 5.60842 4.51247 5.53189L0.150007 1.16942C0.042859 1.06227 -0.00688937 0.939814 0.00076387 0.802052C0.00841807 0.66429 0.0581655 0.534182 0.150007 0.411726Z",
    fill: "black"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["href", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", {
    id: "primary-navigation",
    class: _normalizeClass(
      _ctx.hasSecondLevel ? 'primary-navigation has-subnav' : 'primary-navigation'
    )
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.root?.Children, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.Id,
          class: _normalizeClass(
          item?.Children?.length > 0
            ? 'primary-navigation__item'
            : 'primary-navigation__item primary-navigation__item--no-children'
        )
        }, [
          _createElementVNode("a", {
            href: item.Url,
            class: _normalizeClass(
            item.Active
              ? 'primary-navigation__first-level-link is-active'
              : 'primary-navigation__first-level-link'
          ),
            innerHTML: item.PageTitle
          }, null, 10, _hoisted_2),
          _createElementVNode("input", {
            id: item.Id,
            class: "primary-navigation__subnav-toggle",
            type: "checkbox"
          }, null, 8, _hoisted_3),
          _createElementVNode("label", {
            class: "primary-navigation__subnav-toggle-label",
            for: item.Id
          }, _hoisted_6, 8, _hoisted_4),
          _createElementVNode("nav", {
            class: _normalizeClass(
            item.Active
              ? 'primary-navigation__second-level second-level'
              : 'primary-navigation__second-level'
          )
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.Children, (subitem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: subitem.Id,
                class: "primary-navigation__item"
              }, [
                _createElementVNode("a", {
                  href: subitem.Url,
                  class: _normalizeClass(
                subitem.Active
                  ? 'primary-navigation__second-level-link is-active'
                  : 'primary-navigation__second-level-link'
              ),
                  innerHTML: subitem.PageTitle
                }, null, 10, _hoisted_7)
              ]))
            }), 128))
          ], 2)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "primary-navigation__overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    })
  ], 2))
}